module.exports = __webpack_public_path__ + "static/media/bares-notables-de-buenos-aires.0330a590.md";